import React from 'react';
import DatePicker from 'react-multi-date-picker';
import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import persianFa from 'react-date-object/locales/persian_fa';

interface PersianDatePickerFaProps {
  value: string;
  onChange: (jalaliDate: string) => void;
  placeholder?: string;
  inputClassName?: string;
}

function normalizeDigits(value: string): string {
  return value.replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)));
}

function safeDateObject(value: string): DateObject | undefined {
  const v = normalizeDigits(value);
  if (!/^\d{4}\/\d{2}\/\d{2}$/.test(v)) return undefined;
  return new DateObject({
    date: v,
    format: 'YYYY/MM/DD',
    calendar: persian,
    locale: persianFa,
  });
}

const DEFAULT_INPUT_CLASS =
  'w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';

const PersianDatePickerFa: React.FC<PersianDatePickerFaProps> = ({
  value,
  onChange,
  placeholder = '۱۴۰۵/۰۱/۰۱',
  inputClassName = DEFAULT_INPUT_CLASS,
}) => {
  return (
    <DatePicker
      value={safeDateObject(value)}
      onChange={(d) => {
        if (!d) {
          onChange('');
          return;
        }
        const dateObj = Array.isArray(d) ? d[0] : d;
        if (!dateObj) {
          onChange('');
          return;
        }
        onChange(dateObj.format('YYYY/MM/DD'));
      }}
      calendar={persian}
      locale={persianFa}
      format="YYYY/MM/DD"
      calendarPosition="bottom-right"
      containerClassName="w-full"
      inputClass={inputClassName}
      placeholder={placeholder}
    />
  );
};

export default PersianDatePickerFa;
